import React from 'react';
type ProductNameProps = {
  script?: boolean;
  accentClassName?: string;
};
export function ProductName({
  script = false,
  accentClassName = 'text-burgundy'
}: ProductNameProps) {
  return <>
      Salsa & Bachata{' '}
      {script ? <span className={`font-script text-[1.3em] font-normal leading-none ${accentClassName}`} data-id="element-253" data-mp="poi0ok5324v4">
          Instructor Ready
        </span> : <span className={`italic ${accentClassName}`} data-id="element-254" data-mp="1i9rpfo3unf95">Instructor Ready</span>}
    </>;
}